import { Helmet } from "react-helmet-async";

const SITE = "https://www.martingalebets.com";

export default function Seo({
  title,
  description,
  path = "/",
  keywords,
  image = `${SITE}/og-image.png`,
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} · Martingale Playbook`
    : "Martingale Playbook · AI Sports Betting & Arbitrage Scanner";
  const canonical = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
